<template>
    <div class="document-list">
        <div class="row">
            <document-teaser v-for="document in documents" :key="document" :id="document" :col-class="colClass" :show-category="showCategory"></document-teaser>
        </div>
    </div>
</template>

<script>
    import DocumentTeaser from "./DocumentTeaser.vue";

    export default {
        name: "DocumentList",
        components: {DocumentTeaser},
        props: {
            documents: null,
            cols: {
                default: 12
            },
            showCategory: {
                default: true,
            }
        },

        computed: {
            colClass() {
                return `col-sm-${this.cols}`
            }
        }
    }
</script>

<style scoped>

</style>